import React from 'react';
import { Stethoscope, Syringe, Activity, Microscope, Droplet, HeartPulse } from 'lucide-react';
import { services } from '../data/mock';
import { Card, CardContent } from './ui/card';

const iconMap = {
  stethoscope: Stethoscope,
  syringe: Syringe,
  activity: Activity,
  microscope: Microscope,
  droplet: Droplet,
  'heart-pulse': HeartPulse
};

const Services = () => {
  return (
    <section id="services" className="py-20 px-4 bg-white">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Nossos <span className="text-purple-600">Serviços</span>
          </h2>
          <div className="w-24 h-1 bg-purple-600 mx-auto mb-6"></div>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Oferecemos uma ampla gama de serviços veterinários para garantir a saúde e felicidade do seu pet
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service) => {
            const Icon = iconMap[service.icon] || Stethoscope;
            return (
              <Card 
                key={service.id} 
                className="border-2 border-gray-100 hover:border-purple-300 hover:shadow-xl transition-all duration-300 group"
              >
                <CardContent className="p-6">
                  <div className="bg-purple-100 w-14 h-14 rounded-lg flex items-center justify-center mb-4 group-hover:bg-purple-600 transition-colors">
                    <Icon className="w-7 h-7 text-purple-600 group-hover:text-white transition-colors" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">{service.title}</h3>
                  <p className="text-gray-600 leading-relaxed">{service.description}</p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;